
import Swiper, { Navigation, Pagination } from 'swiper'

export default class Sliders {
    static init(){
                
        Swiper.use([Navigation])

        var swiperTemoignage = new Swiper('.swiper-container.temoignage-swipper', {
            direction: 'horizontal',
            loop: true,
            spaceBetween: 30,
            autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            },
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            },
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
        })
        
        var swiperActu = new Swiper('.swiper-container.actualite-swiper', {
            direction: 'horizontal',
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            },
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            },
            navigation: {
            nextEl: '.carousel-control-next',
            prevEl: '.carousel-control-prev',
            },
        })
  
    }
}